import { ReducerCreators, PayloadAction } from '@reduxjs/toolkit';

import { ActivityLogState } from './types';
import { LoadActivityLog } from '@/connection/activity-log/get-activity-log';
import { LoadActivityLogOptions } from '@/connection/activity-log/get-activity-log';
import { RootState } from '@/store/main';

export const reducers = (create: ReducerCreators<ActivityLogState>) => ({
  fetchActivityLog: create.asyncThunk(
    async (
      { channel, projectUuid, opts }: { channel: number; projectUuid: string; opts?: LoadActivityLogOptions },
      { getState }
    ) => {
      const state = (getState() as RootState).activityLog as ActivityLogState;

      if (state.noMoreActivities) {
        return { activities: [], next: undefined };
      }

      const response = await LoadActivityLog(channel, projectUuid, { ...(opts || {}), published: true });
      return response;
    },
    {
      fulfilled: (state, action) => {
        state.activityLogCursor = action.payload.next;
        state.activityLog = [...(state.activityLog || []), ...action.payload.activities];
        state.loadingActivityLog = false;
        if (!action.payload.next) {
          state.noMoreActivities = true;
        }
      },
      pending: (state) => {
        state.loadingActivityLog = true;
      },
      rejected: (state, action) => {
        state.loadingActivityLog = false;
        console.error(action.error);
      },
    }
  ),
  setShowActivityLogModal: create.reducer((state, action: PayloadAction<boolean>) => {
    state.showActivityLogModal = action.payload;
  }),
});
